import React from 'react';
import { Instagram, Phone, Mail, MapPin, ArrowUp } from 'lucide-react';
import { brandData } from '../data/mock';

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0a0a0a] text-white">
      {/* Main Footer */}
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img 
              src={brandData.mainBrand.logo}
              alt="DRM Kitchen"
              className="h-16 w-auto object-contain mb-6 opacity-90"
            />
            <p className="text-sm text-[#8a8a8a] leading-relaxed font-light">
              {brandData.mainBrand.tagline}
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase text-[#c9a962] mb-6">Hızlı Erişim</h4>
            <ul className="space-y-3">
              <li>
                <a href="#hero" className="footer-link text-sm text-[#8a8a8a] hover:text-white transition-colors">
                  Ana Sayfa
                </a>
              </li>
              <li>
                <a href="#brands" className="footer-link text-sm text-[#8a8a8a] hover:text-white transition-colors">
                  Markalarımız
                </a>
              </li>
              <li>
                <a href="#contact" className="footer-link text-sm text-[#8a8a8a] hover:text-white transition-colors">
                  İletişim
                </a>
              </li>
            </ul>
          </div>

          {/* Brands */}
          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase text-[#c9a962] mb-6">Markalar</h4>
            <ul className="space-y-3">
              {brandData.subBrands.slice(0, 5).map((brand) => (
                <li key={brand.id}>
                  <a 
                    href={brand.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-link text-sm text-[#8a8a8a] hover:text-white transition-colors"
                  >
                    {brand.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm tracking-[0.2em] uppercase text-[#c9a962] mb-6">İletişim</h4>
            <ul className="space-y-4">
              <li>
                <a 
                  href={`tel:${brandData.contact.phone.replace(/\s/g, '')}`}
                  className="flex items-center gap-3 text-sm text-[#8a8a8a] hover:text-white transition-colors"
                >
                  <Phone size={14} strokeWidth={1.5} className="text-[#c9a962]" />
                  {brandData.contact.phone}
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${brandData.contact.email}`}
                  className="flex items-center gap-3 text-sm text-[#8a8a8a] hover:text-white transition-colors"
                >
                  <Mail size={14} strokeWidth={1.5} className="text-[#c9a962]" />
                  <span className="break-all">{brandData.contact.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-sm text-[#8a8a8a]">
                <MapPin size={14} strokeWidth={1.5} className="text-[#c9a962] mt-1 flex-shrink-0" />
                <span>{brandData.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-xs text-[#4a4a4a] tracking-wide">
              © {currentYear} DRM Kitchen. Tüm hakları saklıdır.
            </p>
            <a 
              href={brandData.mainBrand.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-xs text-[#8a8a8a] hover:text-[#c9a962] transition-colors"
            >
              <Instagram size={14} strokeWidth={1.5} />
              <span>{brandData.mainBrand.instagram}</span>
            </a>
            <button 
              onClick={scrollToTop}
              className="flex items-center gap-2 text-xs text-[#8a8a8a] hover:text-[#c9a962] transition-colors group"
            >
              <span className="tracking-wide">Yukarı</span>
              <ArrowUp size={14} strokeWidth={1.5} className="group-hover:-translate-y-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};
